import React, { useState, useEffect, useMemo, Fragment } from 'react';
import { ListLayout } from '../../containers/Layout';

import FormPrepa from '../../sales/FormPrepa';
import { TableHead, TableBody, TableRow, TableCell, Button, IconButton, Box, Menu, MenuItem, Typography, Checkbox } from '@material-ui/core';
import DeleteDialog from '../../../../../commonModules/interface/DeleteDialog';
import PopUp from '../../../../../commonModules/interface/PopUp';
import { AddRounded,  DeleteRounded,  MoreVertRounded, IndeterminateCheckBoxOutlined } from '@material-ui/icons';
import TableFooterPagination from '../../../../../commonModules/interface/TableFooterPagination';
import { isEmpty, size, sumBy, sum } from 'lodash';
import ClientPopUp from '../../clients/ClientPopUp';
import SingleSaleCredits from '../../credits/SingleSaleCredits';
import FormCredit from '../../credits/FormCredit';
import { deepPurple,  red } from '@material-ui/core/colors';
import Currency from '../../../../../commonModules/Currency';
import { toast } from 'react-toastify';
import { useFetchTransfers } from '../../../../../../../../jsx/hooks/getTransfers';
import { useSelector, useDispatch } from 'react-redux';
import LinkSalePopUp from './LinkSalePopUp';
import { getIncomeInfo } from '../../../../../../../../jsx/actions/paymentAction';
import { fetchTransferDetails } from '../../../../../../../../jsx/actions/transferAction';
import { handleBulkDownloadPDFs } from '../../../../../../../../jsx/utils/transferPDFGenerator';
import { primaryFactId, linkedAmount, isOperationMatched, pointedAmount } from '../../../../../../../../jsx/utils/factId5000';
import MatchingStatus, { matchingRowColor } from '../../../../../commonModules/MatchingStatus';
import { useCurrency } from '../../../../../../../../jsx/hooks/useCurrency';

const ListTransferSale = (props) => {
    const dispatch = useDispatch();
    const fetchTransfers = useFetchTransfers(props.dataview);
    const currency = useCurrency();
    // Les montants sont stockés dans la devise du compte : sans cette indication, Currency
    // les libellerait tous en FCFA, ce qui est faux pour les comptes en Euro ou en dollar.
    // Repli sur FCFA quand le compte ne déclare pas de devise.
    const displayCurrency = currency || 'FCFA';
    const showCreditPaidColumn = props.showCreditPaidColumn === true;
	const SHOPS = useSelector((state) => state.inventory.shops); 
	const CLIENTS = useSelector((state) => state.inventory.clients); 
	const SALES = useSelector((state) => state.inventory.sales.SALES); 
	const QUOTES = useSelector((state) => state.inventory.sales.QUOTES); 
	const AGENTS = useSelector((state) => state.agents.agents); 
	const PRODUCTS = useSelector((state) => state.inventory.products);
	const STATE = useSelector((state) => state.inventory.requestState);
	const SOCIETY = useSelector((state) => state.society);

    const [dialogPrepa, setDialogPrepa] = useState(false);
    const [prepa, setPrepa] = useState({
        id: "",
        nature: "payg"
    });

    const [deletePopUp, setDeletePopUp] = useState(false);
    const [toDelete, setToDelete] = useState({
        id: ""
    });

    const [currentPage,setCurrentPage] = useState(0);
    const [pageOfItems,setPageOfItems] = useState(20);

    const [allChecked, setAllChecked] = useState(false);

    const [view, setView] = useState("list");
    const [clientPopUp, setClientPopUp] = useState(false);
    const [sale, setSale] = useState({});
    const [client, setClient] = useState({});
    const [openMenu, setOpenMenu] = useState("");
    const [anchorEl, setAnchorEl] = useState(null);
    const [currentMenuSale, setCurrentMenuSale] = useState(null);
    
    const [checkedPayments, setCheckedPayments] = useState([]);
    const [newPayment, setNewPayment] = useState(false);
    const [paymentsDetails, setPaymentsDetails] = useState(false);
    const [parts, setParts] = useState({});
    const [totalPay, setTotalPay] = useState(0);
    const [incomeID, setIncomeID] = useState(0);
    const [openLink, setOpenLink] = useState(false);
    const [openUnLink, setOpenUnLink] = useState(false);
    const [unlink, setUnlink] = useState({});
    // Une opération est souvent rattachée à plusieurs écritures 5000 : on lit lesquelles, et on
    // laisse choisir celle à défaire au lieu de prendre la première de fact_id_5000.
    const [unlinkParts, setUnlinkParts] = useState(null);
    const [unlinkChoice, setUnlinkChoice] = useState("");
    const [sortDSC, setSortDSC] = useState(false);
    const [prefillParts, setPrefillParts] = useState({});
    const [linkPopupTitle, setLinkPopupTitle] = useState("Pointer les ventes");
    const [downloadingPDF, setDownloadingPDF] = useState(false);

    const [saleList, setSaleList] = useState([]);
    const [saleListVeaw, setSaleListVeaw] = useState([]);
    const [saleListInitial, setSaleListInitial] = useState([]);
    // Les paiements annulés restent en base avec credit_validate = false :
    // ils ne comptent ni dans le payé ni dans le reste à payer (aligné sur storehouse).
    const paidCreditsBySale = useMemo(() => {
        const grouped = {};
        Object.values(props.SALE_CREDITS || {}).forEach((credit) => {
            if (!credit?.sale_id || credit.credit_validate === false) return;
            grouped[credit.sale_id] = (grouped[credit.sale_id] || 0) + (parseFloat(credit.amount || 0) || 0);
        });
        return grouped;
    }, [props.SALE_CREDITS]);
    const creditPaymentStatsBySale = useMemo(() => {
        const grouped = {};
        Object.values(props.SALE_CREDITS || {}).forEach((credit) => {
            if (!credit?.sale_id || credit.credit_validate === false) return;
            if (!grouped[credit.sale_id]) {
                grouped[credit.sale_id] = { total: 0, pointed: 0 };
            }
            grouped[credit.sale_id].total += 1;
            if (credit.income_id || credit.fact_id_5000) {
                grouped[credit.sale_id].pointed += 1;
            }
        });
        return grouped;
    }, [props.SALE_CREDITS]);

    useEffect(() => {
        if ( props.dataview === "vente"){
            if(isEmpty(SALES)){
                fetchTransfers();
            }else{
                setSaleListInitial(SALES)
            }
        }
        if ( props.dataview === "quote"){
            if(isEmpty(QUOTES)){
                fetchTransfers();
            }else{
                setSaleListInitial(QUOTES)
            }
        }
    }, []);
    useEffect(() => {
        if (!isEmpty(SALES) && props.dataview === "vente"){
            setSaleListInitial(SALES)
            setSaleList(SALES)
		}
    }, [SALES]);

    useEffect(() => {
        if (!isEmpty(QUOTES) && props.dataview === "quote"){
            setSaleListInitial(QUOTES)
            setSaleList(QUOTES)
		}
    }, [QUOTES]);

    useEffect(() => {
        const saleList = displayList();
		setSaleListVeaw(saleList)
    }, [checkedPayments,saleListInitial,currentPage,pageOfItems]);
    useEffect(() => {
        if (currentPage === 0){
            const saleList = displayList();
            setSaleListVeaw(saleList)
        }else{
            setCurrentPage(0)
        }
    }, [
        props.start_date,
        props.end_date,
        props.selectShop,
        props.searchClient,
        props.searchFacture,
        props.searchType,
        props.searchCredit,
        props.searchPointing5000,
        props.searchPointing,
        props.searchPaymentStatus
    ]);



    const handleClick = (event, payID) => {
        const selectedIndex = checkedPayments.indexOf(payID);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(checkedPayments, payID);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(checkedPayments.slice(1));
        } else if (selectedIndex === checkedPayments.length - 1) {
            newSelected = newSelected.concat(checkedPayments.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                checkedPayments.slice(0, selectedIndex),
                checkedPayments.slice(selectedIndex + 1),
            );
        }

        setCheckedPayments(newSelected);
        setTotalPay(calcTotal(newSelected));
    };

    const handleSelectAllClick = (event, list) => {
        if (event && event.target.checked) {
            const listAll = list.map(sale => sale.id);
            let newList = listAll.slice(pageOfItems*(currentPage),pageOfItems*(currentPage+1))
            .filter(ID => SALES[ID].match_available && SALES[ID].nature !== "payg" && !SALES[ID].sale_credit)
            setCheckedPayments(newList);
            setAllChecked(true);
            return;
        }
        setAllChecked(false);
        setCheckedPayments([]);
        setTotalPay(0);
        setIncomeID("");
        setOpenLink(false);
        setOpenUnLink(false);
    };

    const createSaleList = (list) => {
        const isSelected = name => checkedPayments.indexOf(name) !== -1;

        return list.slice(pageOfItems*(currentPage),pageOfItems*(currentPage+1)).map((sale, index) => {
            if (sale) {
                const client = CLIENTS[sale.client_id];
                const shop = SHOPS[sale.shop_id];
                const agent = AGENTS && AGENTS[sale.commercial_id];
                const paidTotal = sale.sale_credit ? getCreditPaymentsTotal(sale.id) : 0;
                const totalToPay = parseFloat(sale.total_price_TTC ?? sale.total_price ?? 0);
                const paidTotalLabel = (Math.round((paidTotal || 0) * 100) / 100).toLocaleString('fr-FR', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2
                });
                const paymentStats = creditPaymentStatsBySale[sale.id] || { total: 0, pointed: 0 };
                let pointedCount = paymentStats.pointed;
                const totalPaymentsCount = paymentStats.total;
                if (totalPaymentsCount > 0 && pointedCount === 0 && sale.fact_id_5000) {
                    pointedCount = totalPaymentsCount;
                }
                if (pointedCount > totalPaymentsCount) {
                    pointedCount = totalPaymentsCount;
                }
                const allPaymentsPointed = totalPaymentsCount > 0 && pointedCount === totalPaymentsCount;
                const amountPointed = pointedAmount(sale);
                return (
                    <TableRow key={sale.id} 
                    style={{ 
                        backgroundColor: sale.sale_waiting_payment ? deepPurple[50] : matchingRowColor(sale),
                        textDecoration: sale.is_deleted ? "line-through" : undefined,
                        color: sale.is_deleted ? "grey" : undefined,
                        fontStyle: sale.is_deleted ? "italic" : undefined,
                        textDecorationThickness: sale.is_deleted ? "2px" : "auto"
                    }}
                    >
                        <TableCell
                            padding="checkbox"
                        >
                            {sale.match_available && sale.nature !== "payg" && !sale.sale_credit &&
                                <Checkbox
                                    onClick={event => handleClick(event, sale.id)}
                                    checked={isSelected(sale.id)}
                                    inputProps={{ 'aria-labelledby': `enhanced-table-checkbox-${index}` }}
                                />
                            }
                            {isOperationMatched(sale) &&
                                <Box p={1}>
                                    <IndeterminateCheckBoxOutlined
                                        onClick={() => openUnlink(sale)}
                                        style={{ color: red[100] }}
                                    />
                                </Box>
                            }
                        </TableCell>
                        {showCreditPaidColumn &&
                            <TableCell>
                                {allPaymentsPointed ? (
                                    <IndeterminateCheckBoxOutlined
                                        style={{ color: red[100], verticalAlign: "middle" }}
                                    />
                                ) : (
                                    <>{pointedCount} / {totalPaymentsCount}</>
                                )}
                            </TableCell>
                        }
                        <TableCell>{(new Date(sale.creation_date)).toLocaleString('fr-FR')}</TableCell>
                        <TableCell>{sale.nature} {sale.sale_credit && " - crédit"}</TableCell>
                        <TableCell>{sale.intern_ref_id || sale.id}</TableCell>
                        <TableCell>
                            {shop ? (
                                <a href="#" onClick={() => props.handleSingleShop(shop)}> {shop.name} </a>
                            ) : (
                                <span>{sale.shop_id}</span>
                            )}
                        </TableCell>
                        <TableCell>{client ? (
                            <a href="#" onClick={() => {setClient(client); setClientPopUp(true)}}>{client.client_firstname} {client.client_lastname}</a>
                        ) : sale.client_id ? (
                            <span title={`Client Payg (boxassociation): ${sale.client_id}`}>Client Payg</span>
                        ) : null}
                        </TableCell>
                        <TableCell><Currency value={sale.total_price} sourceCurrency={displayCurrency} /></TableCell>
                        <TableCell><Currency value={sale.total_price_TTC ?? sale.total_price} sourceCurrency={displayCurrency} /></TableCell>
                        <TableCell>
                            {amountPointed === null
                                ? <span title="Reste à pointer incohérent avec le montant de la vente">—</span>
                                : <Currency value={amountPointed} sourceCurrency={displayCurrency} />}
                        </TableCell>
                        <TableCell><MatchingStatus operation={sale} currency={displayCurrency} /></TableCell>
                        {showCreditPaidColumn &&
                            <TableCell>
                                {paidTotalLabel} / <Currency value={totalToPay} sourceCurrency={displayCurrency} />
                            </TableCell>
                        }
                        <TableCell>
                            <IconButton
                                color="secondary"
                                onClick={() => props.handleSingleSale(sale, shop, client, agent)}
                            >
                                <AddRounded />
                            </IconButton>
                        </TableCell>
                        <TableCell>
                            {sale.sale_credit &&
                                <Fragment>
                                    <IconButton
                                        aria-controls={`option-menu${sale.id}`}
                                        aria-haspopup="true"
                                        onClick={event => {
                                            setAnchorEl(event.currentTarget); 
                                            setOpenMenu(sale.id);
                                            setCurrentMenuSale({ sale, client });
                                        }}
                                    >
                                        <MoreVertRounded fontSize="small" />
                                    </IconButton>
                                </Fragment>
                            }

                            {sale.nature !== "prepa" && sale.shop_id !== "Commercial" && !sale.sale_credit && !sale.is_deleted &&
                                <IconButton onClick={() => {
                                    setToDelete(sale);
                                    setDeletePopUp(true);
                                }}>
                                    <DeleteRounded color="error" />
                                </IconButton>
                                
                            }
                        </TableCell>
                    </TableRow>
                );
            }
        });
    };

    const displayList = () => {
        let tab = [];
        if (!isEmpty(saleListInitial)) {
            let filteredList = props.getFilteredList(saleListInitial);
            setSaleList(filteredList)
            tab = createSaleList(filteredList);
        }
        return tab;
    };

    const handleOpenPayments = (sale, client) => {
        setSale(sale);
        setClient(client);
        setPaymentsDetails(true);
        setOpenMenu("");
        setAnchorEl(null);
        setCurrentMenuSale(null);
    };

    const handleOpenNewPayment = (sale, client) => {
        setSale(sale);
        setClient(client);
        setNewPayment(true);
        setOpenMenu("");
        setAnchorEl(null);
        setCurrentMenuSale(null);
    };

    const getCreditPaymentsTotal = (saleID) => {
        return paidCreditsBySale[saleID] || 0;
    };

    const openLinkPopupForSale = (sale, mode = "sale") => {
        const saleAvailable = parseFloat(sale.total_available || sale.total_price || 0);
        const paidByCredits = getCreditPaymentsTotal(sale.id);
        const amountToLink = mode === "payments"
            ? Math.min(saleAvailable, paidByCredits > 0 ? paidByCredits : saleAvailable)
            : saleAvailable;

        setCheckedPayments([sale.id]);
        setParts({ [sale.id]: amountToLink });
        setPrefillParts({ [sale.id]: amountToLink });
        setTotalPay(amountToLink);
        setLinkPopupTitle(mode === "payments" ? "Pointer les paiements crédit" : "Pointer la vente");
        setOpenLink(true);
        setOpenMenu("");
        setAnchorEl(null);
        setCurrentMenuSale(null);
    };

    const rmPayment = (payID) => {
        let cpParts = { ...parts };
        let newList = [...checkedPayments];
        newList = newList.filter(id => id !== payID);
        delete cpParts[payID];
        setCheckedPayments(newList);
        setParts(cpParts);
        setTotalPay(calcTotalV2(newList));
    };

    const handleChangeParts = (newParts) => {
        setParts(newParts);
        setTotalPay(sum(Object.values(newParts)));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'incomeID') {
            setIncomeID(value);
        }
    };

    const handleGetIncomeInfo = async (id) => {
        return await dispatch(getIncomeInfo(id));
    };

    const handleSubmitLink = async () => {
        let data = {
            income_id: incomeID,
            id_list: parts,
            total: calcTotalV2(checkedPayments),
        };
        const issue = await props.linkSalesTo5000(data);
        // L'action rend son résultat : STATE vient de useSelector et garde, après l'await,
        // la valeur capturée au rendu — un échec y passait pour un succès.
        if (issue && issue.ok === false) {
            toast.error(issue.error || "Le rapprochement n'a pas abouti.");
            return;
        }
        toast.info('Opération enregistrée avec succès');
        handleSelectAllClick();
        setPrefillParts({});
        setLinkPopupTitle("Pointer les ventes");
    };

    // Ouvre le dépointage sur une opération : lit ses rattachements pour que l'on puisse

    // désigner la facture à défaire, et savoir quel montant sera rendu.

    const openUnlink = async (operation) => {

    	setUnlink(operation);

    	setUnlinkParts(null);

    	setUnlinkChoice("");

    	setOpenUnLink(true);

    	try {

    		const req = await fetch('/stocks/compta/sales/parts', {

    			method: 'POST',

    			headers: { 'Content-Type': 'application/json' },

    			body: JSON.stringify({ sale_id: operation.id }),

    			credentials: 'same-origin',

    		});

    		const res = await req.json();

    		const parts = res.error ? [] : (res.parts || []);

    		setUnlinkParts(parts);

    		// Une seule écriture : rien à choisir.

    		if (parts.length === 1) setUnlinkChoice(parts[0].entry_id);

    	} catch (error) {

    		console.log("[ERROR] lecture des rattachements : ", error);

    		setUnlinkParts([]);

    	}

    };

    

    // Montant rattaché à l'écriture retenue : c'est lui que le serveur rendra à la

    // comptabilité, et non le montant de l'opération.

    const chosenAmount = () => {

    	const part = (unlinkParts || []).find((p) => p.entry_id === unlinkChoice);

    	return part ? part.amount : 0;

    };

    

    const handleSubmitUnLink = async (password) => {
        let data = {
            // fact_id_5000 est une liste d'écritures séparées par ", " : transmettre la
            // chaîne brute ne correspondait à aucune écriture côté back (COMPTA-219).
            income_id: unlinkChoice,
            id_list: { [unlink.id]: linkedAmount(unlink) },
            // le pointage débite le TTC ; recréditer le HT décalait le solde de l'écriture 5000.
            total: linkedAmount(unlink),
        	// Le mot de passe saisi dans DeleteDialog était recueilli puis abandonné :
        	// il part désormais au serveur, qui le vérifie.
        	password,
        };
        const issue = await props.unLinkSalesTo5000(data);
        // L'action rend son résultat : STATE vient de useSelector et garde, après l'await,
        // la valeur capturée au rendu — un échec y passait pour un succès.
        if (issue && issue.ok === false) {
            toast.error(issue.error || "Le rapprochement n'a pas abouti.");
            return;
        }
        toast.info('Opération enregistrée avec succès');
        handleSelectAllClick();
    };

    const calcTotal = (list) => {
        return sumBy(list, (saleID) => SALES[saleID].total_available);
    };

    const calcTotalV2 = (list) => {
        return sumBy(list, (saleID) => parts[saleID]);
    };

    const handleBulkDownloadInvoices = async () => {
        if (downloadingPDF || size(checkedPayments) === 0) return;
        setDownloadingPDF(true);
        try {
            await handleBulkDownloadPDFs({
                checkedIds: checkedPayments,
                transfersMap: SALES,
                shops: SHOPS,
                clients: CLIENTS,
                products: PRODUCTS || {},
                society: SOCIETY || {},
                fetchDetails: (id) => dispatch(fetchTransferDetails(id)),
                options: { currency: currency || 'FCFA' },
                nature: 'vente',
            });
        } finally {
            setDownloadingPDF(false);
        }
    };

    const deleteSale = async (password) => {
        try{
            const saleWithPassword = { ...toDelete, password: password || "" };
            const resp = await props.deleteSale(saleWithPassword);
            toast.success("Vente supprimée avec succès");
            setDeletePopUp(false);
            setToDelete({ id: "" });
            setOpenMenu("");
            setAnchorEl(null);
        }catch(err){
            console.log("[ERROR] delete sale", err.message);
            const errorMsg = err?.message || String(err);
            if(errorMsg.includes('Mot de passe') || errorMsg.includes('password')){
                toast.error(errorMsg);
            } else {
                toast.error("Un Problème est survenu: " + errorMsg);
            }
        }
    };


    const onChangePage = (pageOfItemsTmp, page, rowsPerPage) => {
        if (!(typeof rowsPerPage === "undefined")){
            setPageOfItems(Number(rowsPerPage))  
        }
        setCurrentPage(Number(page))
    }

    return (
        <>
            {deletePopUp &&
                <DeleteDialog
                        title={"la vente n°" + toDelete.id}
                        handleSubmit={deleteSale}
                        block={true}
                        close={() => setDeletePopUp(false)}
                 />
            }

            {dialogPrepa &&
                <FormPrepa
                    {...props}
                    prepa={prepa}
                    handleClose={() => setDialogPrepa(false)}
                />
            }
            {paymentsDetails &&
                <SingleSaleCredits
                    title="Liste des paiement"
                    sale={sale}
                    client={client}
                    {...props}
                    closePopUp={() => setPaymentsDetails(false, setSale({}, setClient({})))}
                />
            }
            {newPayment &&
                <FormCredit
                    sale={sale}
                    client={client}
                    {...props}
                    closePopUp={() => setNewPayment(false, setSale({}, setClient({})))}
                />
            }
            {clientPopUp && !isEmpty(client) &&
                <ClientPopUp
                    client={client}
                    {...props}
                    closePopUp={() => setClientPopUp(false, setClient({}))}
                />
            }

            {size(checkedPayments) > 0 &&
                <div>
                    <Button variant="contained" color="primary" onClick={() => {
                        setPrefillParts({});
                        setLinkPopupTitle("Pointer les ventes");
                        setOpenLink(true);
                    }}>
                        Pointer {size(checkedPayments)} paiements
                    </Button>
                    <Button variant="contained" color="primary" onClick={handleBulkDownloadInvoices} disabled={downloadingPDF}>
                        {downloadingPDF ? 'Téléchargement...' : `Télécharger ${size(checkedPayments)} Facture`}
                    </Button>
                </div>
            }
            {openLink && size(checkedPayments) > 0 &&
                <LinkSalePopUp
                    handleClose={() => setOpenLink(false, setIncomeID(""))}
                    rmPayment={rmPayment}
                    handleSubmitLink={handleSubmitLink}
                    handleChange={handleChange}
                    handleChangeParts={handleChangeParts}
                    getIncomeInfo={handleGetIncomeInfo}
                    incomeID={incomeID}
                    checkedPayments={checkedPayments}
                    totalPay={totalPay}
                    initialParts={prefillParts}
                    title={linkPopupTitle}
                    SALES={SALES}
                    CLIENTS={CLIENTS}
                    // {...props}
                />
            }
            {openUnLink && !isEmpty(unlink) && !unlinkChoice && (
				<PopUp
					close={() => { setOpenUnLink(false); setUnlink({}); setUnlinkParts(null); }}
					submitAction={() => {}}
					disabledSubmit={true}
					maxWidth="xs"
					title="Choisir la recette à dépointer"
				>
					<Box p={1}>
						{unlinkParts === null && <Typography variant="body2">Lecture des rattachements…</Typography>}
						{unlinkParts && unlinkParts.length === 0 &&
							<Typography variant="body2">Aucun rattachement trouvé pour cette opération.</Typography>}
						{unlinkParts && unlinkParts.map((part) => (
							<Box key={part.entry_id} p={1}>
								<Button fullWidth variant="outlined" onClick={() => setUnlinkChoice(part.entry_id)}>
									{part.entry_id} — <Currency value={part.amount} />
								</Button>
							</Box>
						))}
					</Box>
				</PopUp>
			)}
			{openUnLink && !isEmpty(unlink) && unlinkChoice && (
				<DeleteDialog
					open={true}
					title={`le pointage de ${unlinkChoice}`}
					close={() => { setOpenUnLink(false); setUnlink({}); setUnlinkParts(null); setUnlinkChoice(""); }}
					handleSubmit={handleSubmitUnLink}
				/>
			)}

            {view === "list" && (
                <Box>
                    <Box>
                        <Box p={1}>
                            <Typography variant="h6">Liste des ventes</Typography>
                        </Box>
                        <ListLayout>
                            <TableHead>
                                <TableRow>
                                    <TableCell padding="checkbox">
                                        <Checkbox
                                            indeterminate={size(checkedPayments) > 0 && size(checkedPayments) < saleList.length}
                                            checked={allChecked}
                                            onChange={(e) => handleSelectAllClick(e, saleList)}
                                            inputProps={{ 'aria-label': 'Selectionner tout' }}
                                        />
                                    </TableCell>
                                    {showCreditPaidColumn && <TableCell>Paiements pointes</TableCell>}
                                    <TableCell>
                                        {/* <TableSortLabel
                                            active={true}
                                            direction={sortDSC ? 'desc' : 'asc'}
                                            onClick={() => this.setState({ sortDSC: !this.state.sortDSC})}
                                        >
                                            Date Paiement
                                        </TableSortLabel> */}
                                        Date
                                    </TableCell>
                                    <TableCell>Nature</TableCell>
                                    <TableCell>ID Facture</TableCell>
                                    <TableCell>Shop</TableCell>
                                    <TableCell>Nom Client</TableCell>
                                    <TableCell>Montant HT</TableCell>
                                    <TableCell>Montant TTC</TableCell>
                                    <TableCell>Pointé</TableCell>
                                    <TableCell>Pointage</TableCell>
                                    {showCreditPaidColumn && <TableCell>Paye / TTC</TableCell>}
                                    <TableCell>Détails</TableCell>
                                    <TableCell>Options</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                { saleList.length !== 0  && 
                                    saleListVeaw
                                }
                                { saleList.length === 0  && 
                                <TableRow>
                                    <TableCell colSpan={showCreditPaidColumn ? 14 : 12}>
                                        <div className="text-center">
                                            Cliquez sur{' '}
                                            <Button
                                                color="primary"
                                                className="text-right"
                                                // onClick={() => {
                                                //     setShowNew(true); 
                                                //     setBreadcrumb('Nouveau');
                                                //     // setState({ ...state, showNew: true, breadcrumb: 'Nouveau' });
                                                // }}
                                            >
                                                Nouveau
                                            </Button>{' '}
                                            pour entrer une nouvelle Vente
                                        </div>
                                    </TableCell>
                                </TableRow>
                                }
                            </TableBody>
                            { 
                                <TableFooterPagination 
                                    colSpan={showCreditPaidColumn ? 14 : 12}
                                    count={saleList.length}
                                    onChangePage={onChangePage}
                                    initialPage={0}
                                    page={currentPage}
                                />         
                            }           
                        </ListLayout>
                    </Box>
                </Box>
            )}

            {/* Menu unique pour toutes les ventes avec sale_credit */}
            {currentMenuSale && currentMenuSale.sale && (
                <Menu
                    id={`option-menu${currentMenuSale.sale.id}`}
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    open={openMenu === currentMenuSale.sale.id}
                    onClose={() => {
                        setOpenMenu(""); 
                        setAnchorEl(null);
                        setCurrentMenuSale(null);
                    }}
                >
                    <MenuItem onClick={() => {
                        handleOpenPayments(currentMenuSale.sale, currentMenuSale.client);
                    }}>
                        Voir les paiements
                    </MenuItem>
                    <MenuItem onClick={() => {
                        handleOpenPayments(currentMenuSale.sale, currentMenuSale.client);
                    }}>
                        Pointer les paiements à 5000
                    </MenuItem>
                    {currentMenuSale.sale.sale_waiting_payment &&
                        <MenuItem onClick={() => {
                            handleOpenNewPayment(currentMenuSale.sale, currentMenuSale.client);
                        }}>
                            Ajouter un paiement
                        </MenuItem>
                    }

                    {currentMenuSale.sale.nature !== "prepa" && currentMenuSale.sale.shop_id !== "Commercial" &&
                       <MenuItem onClick={() => {
                            setToDelete(currentMenuSale.sale);
                            setDeletePopUp(true);
                            setOpenMenu("");
                            setAnchorEl(null);
                            setCurrentMenuSale(null);
                        }}>
                            Supprimer
                        </MenuItem>
                    }
                </Menu>
            )}
        </>
    );
}

export default ListTransferSale;